<div
    class="sidebar-area bg-white"
    [ngClass]="{'active': isSidebarToggled}"
    [class.component-dark-theme]="themeService.isDark()"
    [class.dark-sidebar]="themeService.isSidebarDark()"
    [class.right-sidebar]="themeService.isRightSidebar()"
    [class.hide-sidebar]="themeService.isHideSidebar()"
    [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <div class="logo bg-white">
        <a routerLink="/" class="d-flex align-items-center">
            <img src="assets/images/logo.png" alt="logo-icon" style="width: 130px">
            <span class="fw-semibold"></span>
        </a>
    </div>
    <div
        (click)="toggle()"
        class="burger-menu"
        [ngClass]="{'active': isSidebarToggled}"
    >
        <span class="top-bar"></span>
        <span class="middle-bar"></span>
        <span class="bottom-bar"></span>
    </div>
    <ng-scrollbar visibility="hover">
        <div class="sidebar-inner">
            <div class="sidebar-menu">
                <mat-accordion>
                    <div style="height: 10px;"></div>
                    <a routerLink="/" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <i class="material-symbols-outlined">
                            dashboard
                        </i>
                        <span class="title">
                            Dashboard
                        </span>
                    </a>
                    <a routerLink="/users" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                        <i class="material-symbols-outlined">
                            account_circle
                        </i>
                        <span class="title">
                            Utenti
                        </span>
                    </a>
                    <a routerLink="/lockers" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                        <i class="material-symbols-outlined">
                            dataset
                        </i>
                        <span class="title">
                            Lockers
                        </span>
                    </a>
                    <a routerLink="/authentication" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <i class="material-symbols-outlined">
                            logout
                        </i>
                        <span class="title">Logout</span>
                    </a>
                </mat-accordion>
            </div>
        </div>
    </ng-scrollbar>
</div>
